import { Link, useParams } from "react-router-dom";

import { ResetPasswordForm } from "@/features/auth";

export function ResetPasswordPage() {
  const { token } = useParams<{ token: string }>();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-6 rounded-lg border border-border bg-surface p-8 shadow-card">
        <div className="space-y-1 text-center">
          <Link
            to="/"
            className="inline-block text-2xl font-semibold tracking-display-tight text-copy transition-colors hover:text-primary"
            aria-label="Go to OneShift home"
          >
            OneShift
          </Link>
          <p className="text-sm text-copy-muted">Set a new password</p>
        </div>

        {!token ? (
          <div className="space-y-4 text-center">
            <p className="text-sm text-destructive">No reset token provided.</p>
            <Link
              to="/forgot-password"
              className="inline-block text-sm font-medium text-primary hover:underline"
            >
              Request a new reset link
            </Link>
          </div>
        ) : (
          <ResetPasswordForm token={token} />
        )}
      </div>
    </div>
  );
}
